import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=db1358a0&scoped=true&"
import script from "./VerticalTabs.vue?vue&type=script&lang=js&"
export * from "./VerticalTabs.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=db1358a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1358a0",
  null
  
)

export default component.exports